import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch } from 'src/store/useDispatch';
import { useSelector } from 'react-redux';

import PagePanel from 'src/components/PagePanel';
import { Table } from 'src/components/TableNew';
import PageHeader from 'src/components/PageHeader';
import NoResult from 'src/components/NoResult/NoResult';
import { useSearchQueryEffect } from 'src/hooks/useSearchQueryEffect';

import { fetchWaitingListUsers, resetSearch, updateField, updateSearch } from 'src/store/slice/waitingList';

import { WAITING_LIST_HEADERS } from 'src/utils/constants';

import WaitingListDetailModal from './WaitingListDetailModal';

const WaitingListUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();
  const {
    data: { waitingListUsers, totalCount, totalPages, field, search },
    loading,
  } = useSelector(({ waitingListUsers }) => waitingListUsers);

  const runQuery = useCallback(
    (params: { page: number; field?: string; search: string }) => {
      dispatch(fetchWaitingListUsers({ page: params.page, field: params.field, search: params.search }));
    },
    [dispatch],
  );

  useSearchQueryEffect({
    search,
    field,
    currentPage,
    setCurrentPage,
    query: runQuery,
  });

  useEffect(() => {
    return () => {
      dispatch(resetSearch());
    };
  }, [dispatch]);

  const items =
    waitingListUsers?.map(({ name, address, identification_url, ...rest }: any) => {
      delete rest.__v;

      const userName = name || {};
      const userAddress = address || {};

      return {
        ...rest,
        ...userAddress,
        front: identification_url?.front,
        back: identification_url?.back,
        name: `${userName?.first || ''} ${userName?.last || ''}`.trim() || '—',
      };
    }) ?? [];

  return (
    <PagePanel>
      <PageHeader
        title={`Waiting List (${totalCount})`}
        dropdownTitle={WAITING_LIST_HEADERS[0]}
        dropDownItems={['Name', 'Email', 'Country Code', 'Email Status', 'Address']}
        entity="waitingListUsers"
        updateEntityField={updateField}
        updateEntitySearch={updateSearch}
      />
      {items.length > 0 || loading ? (
        <Table
          loading={loading}
          headers={WAITING_LIST_HEADERS}
          items={items}
          columns="1.2fr 1.2fr 0.9fr 0.9fr 0.9fr 0.8fr"
          fieldsToShow={['name', 'email', 'status', 'country_code', 'city', 'pin_code']}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          renderDetailsModal={(item, onClose) => (
            <WaitingListDetailModal user={item} onClose={onClose} />
          )}
        />
      ) : (
        <NoResult />
      )}
    </PagePanel>
  );
};

export default WaitingListUsers;
